import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OtpFacade } from '@domain/application/facade/otp/otp.facade';
import { SessionService } from '@domain/application/observable-services/session.service';
import { FailedAttemptOtpModel } from '@utils/classes/model/failed-attempt-otp-model';
import { AssetLink } from '@utils/helpers/asset-cpm-link';
import { IOtpMailResponse } from '@utils/interfaces/response';

@Component({
  selector: 'ba-view-otp-error',
  templateUrl: './view-otp-error.component.html',
  styleUrls: ['./view-otp-error.component.scss']
})
export class ViewOtpErrorComponent extends AssetLink() implements OnInit {

  @Output() onShowValidationCodeOtp = new EventEmitter<FailedAttemptOtpModel>();
  @Input() numberOfAttemptsOtpCode!: number;

  isLoading = false;
  descriptionAttempts: string = 'intento';

  constructor(
    private readonly sessionService: SessionService,
    private readonly otpFacade: OtpFacade
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.numberOfAttemptsOtpCode > 1) this.descriptionAttempts = this.descriptionAttempts.concat('s');
  }

  resendCodeViewOtpError() {
    const { otpMailRequest } = this.sessionService.getCommonInfoValue;
    this.otpFacade.otpMail(otpMailRequest).subscribe({
      next: (response: IOtpMailResponse) => {
        this.sessionService.setCommonInfo = { signatureId: response.signatureId };
        this.exitViewOtpError();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  exitViewOtpError() {
    let failedAttemptOtpModel = new FailedAttemptOtpModel();
    failedAttemptOtpModel.showViewOtpError = false;
    failedAttemptOtpModel.showViewLockOtp = false;
    this.onShowValidationCodeOtp.emit(failedAttemptOtpModel);
  }
}